import React, {useEffect, useState} from 'react';
import {FaCalendarAlt, FaEllipsisV, FaPlayCircle, FaUsers} from 'react-icons/fa';
import {Link, useNavigate} from "react-router-dom";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import {excluirDiaDeJogo, finalizarJogoDoDia} from "../services/jogoDoDiaService";
import {alertaDeErro, confirmarAcao} from "../services/alertServices";

export const Home = () => {
    const [stats, setStats] = useState({
        diasJogados: 0,
        jogosRealizados: 0,
        jogadoresAtivos: 0
    });

    const navigate = useNavigate();
    const [historicoDias, setHistoricoDias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [diaDeJogo, setDiaDeJogo] = useState(null);
    const [finalizandoJogoDoDia, setFinalizandoJogoDoDia] = useState(false);
    const [dropdownAbertoId, setDropdownAbertoId] = useState(false);

    useEffect(() => {
        const carregarResumo = async () => {
            try {
                const response = await fetch('/api/DiasDeJogo/Resumo');
                if (!response.ok) {
                    throw new Error('Erro ao carregar resumo');
                }
                const data = await response.json();

                setStats({
                    diasJogados: data.diasJogados,
                    jogosRealizados: data.jogosRealizados,
                    jogadoresAtivos: data.jogadoresAtivos
                });

                setHistoricoDias(data.ultimosDias || []);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };

        const verificarJogosHoje = async () => {
            try {
                const response = await fetch('/api/DiasDeJogo/Atual');
                if (!response.ok || response.status === 204) {
                    setDiaDeJogo(null);
                    return;
                }

                const data = await response.json();
                setDiaDeJogo(data);
            } catch (e) {
                console.error(e);
            }
        };

        carregarResumo();
        verificarJogosHoje();
    }, []);

    const handleCriarDiaDeJogo = async () => {
        setLoading(true);
        try {
            const response = await fetch('/api/DiasDeJogo', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
            });

            if (!response.ok) {
                throw new Error('Erro ao salvar jogador');
            }

            const data = await response.json();
            setDiaDeJogo(data);
            navigate(`/preparar-jogos/${data.id}`);

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizarJogoDoDia = async (idDiaDeJogo) => {
        try {

            const result = await confirmarAcao(
                'Tem certeza?',
                'Você deseja finalizar os jogos deste dia?',
                'Sim, finalizar!'
            );

            if (!result.isConfirmed) {
                return;
            }

            setFinalizandoJogoDoDia(true);

            await finalizarJogoDoDia(idDiaDeJogo);

            navigate(`/`, {state: {mensagem: 'Jogo finalizado com sucesso!'}});

        } catch (e) {
            console.error(e);
            await alertaDeErro(e.message || 'Erro ao finalizar dia de jogo');
        } finally {
            setFinalizandoJogoDoDia(false);
        }
    };

    const handleExcluir = async (idDiaDejogo) => {
        const result = await confirmarAcao(
            'Tem certeza?',
            'Você deseja excluir este dia de jogo?',
            'Sim, excluir!'
        );
        if (!result.isConfirmed) {
            return;
        }

        try {
            await excluirDiaDeJogo(idDiaDejogo);
            setHistoricoDias(historicoDias.filter(dia => dia.id !== idDiaDejogo));
            if (diaDeJogo && diaDeJogo.id === idDiaDejogo) {
                setDiaDeJogo(null);
            }
        } catch (e) {
            console.error(e);
            await alertaDeErro(e.message || 'Erro ao excluir dia de jogo');
        }
    };

    const toggleDropdownDia = (idDia) => {
        setDropdownAbertoId((atual) => (atual === idDia ? null : idDia));
    };

    const renderCardsResumo = () => (
        <div className="row mb-2">
            <div className="col-md-4 mb-3">
                <div className="card h-100 shadow-sm border-primary">
                    <div className="card-body d-flex align-items-center">
                        <FaCalendarAlt size={40} className="text-primary me-3"/>
                        <div>
                            <h3 className="card-title mb-0 fw-bold">{stats.diasJogados}</h3>
                            <p className="card-text text-muted mb-0">Dias jogados</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4 mb-3">
                <div className="card h-100 shadow-sm border-danger">
                    <div className="card-body d-flex align-items-center">
                        <FaPlayCircle size={40} className="text-danger me-3"/>
                        <div>
                            <h3 className="card-title mb-0 fw-bold">{stats.jogosRealizados}</h3>
                            <p className="card-text text-muted mb-0">Jogos realizados</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4 mb-3">
                <Link to="/jogadores" className="text-decoration-none text-dark">
                    <div className="card h-100 shadow-sm border-success">
                        <div className="card-body d-flex align-items-center">
                            <FaUsers size={40} className="text-success me-3"/>
                            <div>
                                <h3 className="card-title mb-0 fw-bold">{stats.jogadoresAtivos}</h3>
                                <p className="card-text text-muted mb-0">Jogadores ativos</p>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    );

    const renderHistoricoDias = () => {
        if (loading) {
            return <p>Carregando últimos dias...</p>;
        }

        return (
            <>
                <div className="d-flex justify-content-between mb-3">
                    <h4>Últimos dias</h4>
                    <button className="btn btn-outline-warning text-dark border-0">Ver todos</button>
                </div>

                <div className="row">
                    <div className="col-12">
                        {historicoDias.map(dia => (
                            <div key={dia.id} className="card mb-2 shadow-sm">
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <Link to={`/jogos-do-dia/${dia.id}`} className="text-decoration-none text-dark d-flex align-items-center flex-grow-1">
                                        <div className="d-flex align-items-center">
                                            <FaCalendarAlt size={30} className="text-primary me-3"/>
                                            <div>
                                                <h5 className="mb-1 fw-bold">{new Date(dia.data).toLocaleDateString('pt-BR')}</h5>
                                                <p className="mb-0 text-muted">
                                                    {dia.quantidadeDeJogos} jogos realizados
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="d-flex align-items-center">
                                        {dia.status === 1 ? (
                                            <span className="badge bg-success">Finalizado</span>
                                        ) : (
                                            <span className="badge  text-bg-warning">Em andamento</span>
                                        )}
                                    </div>

                                    <Dropdown
                                        isOpen={dropdownAbertoId === dia.id}
                                        toggle={() => toggleDropdownDia(dia.id)}
                                        className="ms-2"
                                    >
                                        <DropdownToggle
                                            color="transparent"
                                            disabled={finalizandoJogoDoDia}
                                        >
                                            <FaEllipsisV/>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {
                                                dia.status === 0 &&
                                                <>
                                                    <DropdownItem
                                                        onClick={() => handleFinalizarJogoDoDia(dia.id)}
                                                        disabled={finalizandoJogoDoDia}
                                                    >
                                                        {finalizandoJogoDoDia ? 'Finalizando...' : 'Finalizar'}
                                                    </DropdownItem>
                                                    <DropdownItem divider/>
                                                </>
                                            }
                                            <DropdownItem
                                                onClick={() => handleExcluir(dia.id)}
                                            >
                                                Excluir
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </div>
                        ))}

                        {historicoDias.length === 0 && !loading && (
                            <p className="text-muted">Nenhum dia de jogo cadastrado ainda</p>
                        )}
                    </div>
                </div>
            </>
        );
    };

    return (
        <div className="container">
            <div className="text-center py-3">
                <FaPlayCircle size={60} className="text-primary mb-4"/>
                <h1 className="display-5 fw-bold mb-3">Pronto para jogar?</h1>
                <p className="lead text-muted mb-4">
                    Inicie um novo dia de jogos e organize suas partidas
                </p>

                {
                    (!diaDeJogo || diaDeJogo.status === 1)
                    &&
                    <a className="btn btn-primary btn-lg px-5 me-2" onClick={handleCriarDiaDeJogo}>
                        Iniciar jogos
                    </a>
                }
                {
                    (diaDeJogo && diaDeJogo.status === 0)
                    &&
                    <Link to={`/jogos-do-dia/${diaDeJogo.id}`} className="btn btn-success btn-lg px-5 me-2">
                        Continuar jogos de hoje
                    </Link>
                }
            </div>

            {renderCardsResumo()}
            {renderHistoricoDias()}
        </div>
    );
};
